<template>
    <v-dialog
        v-model="abrir"
        max-width="550px" 
        scrollable
        persistent>
        
        <v-card ref="form">
            <v-card-title>
                <span class="headline">{{ titulo }}</span>
            </v-card-title>

            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex cols xs12 sm12 md12>
                            <label class="body-1 grey--text">Imagen de codigo QR<br>
                                <input 
                                    type="file" 
                                    :id = "imgqr" 
                                    ref="imgqr" 
                                    accept="image/x-png,image/gif,image/jpeg,image/jpg" 
                                    @change = "manejoQR">
                                <br><br>
                            </label>
                        </v-flex>
                </v-layout>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn
                color="blue darken-1"
                text
                @click="cerrar">Cancelar</v-btn>
                <v-btn
                color="blue darken-1"
                text
                @click="guardar">Agregar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ServiceHandler from '../../ServiceHandler';

export default {
    props: {
        numarete: String, 
        abrir: Boolean,
        titulo: String
    },
    data() {
        return {
            qrcode: '',
            imgqr: '',
        }
    },
    methods: {
        manejoQR(){
            this.imgqr = this.$refs.imgqr.files[0];
        },
        async guardar() {
            try{
                if(typeof this.imgqr.name != 'string'){
                    alert("Hubo un error al subir el QR. Asegurese que la imagen se haya seleccionado correctamente. Si el problema persiste, comuníquese con el administrador del sistema");
                }else{
                    console.log("entre a guardar");
                    let formDataQR = new FormData();                      
                    var tmpQR = this.imgqr.name.split(".");
                    var qn = '';
                    if(tmpQR.length <= 1){
                        qn = this.numarete;
                    }else{
                        qn = `${this.numarete}.${tmpQR[tmpQR.length-1]}`
                    }
                    this.qrcode = `/qrs/${qn}`;
                                            
                    formDataQR.append('imgqr', this.imgqr, qn);
                    formDataQR.append('numarete', this.numarete);
                    formDataQR.append('qrcode', this.qrcode);
                    console.log("entrando a subir imagen");
                    await ServiceHandler.subirImagen("qrcode", formDataQR); 
                    this.cerrar();
                    this.$emit('actualizarTabla');   
                    alert("Se ha guardado QR");  
                }   
            }catch(e){
                this.error = e.message;
            }
        },
        cerrar() {
            //this.abrir = false;
            this.$emit('cerrarVentana');
        },
    },
}
</script>